import {ChangeDetectionStrategy, Component, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {INgClass} from '@ideals/types';

export const SWITCH_ON_CLASS = 'switch-on';

const NG_VALUE_ACCESSOR_PROVIDER = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ToggleComponent),
  multi: true
};

@Component({
  selector: 'ideals-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [NG_VALUE_ACCESSOR_PROVIDER]
})
export class ToggleComponent implements ControlValueAccessor {
  public value = false;

  private _onModelChange: (checked: boolean) => void;

  public get switcherClasses(): INgClass {
    return {
      [SWITCH_ON_CLASS]: this.value,
    };
  }

  public registerOnChange(fn: any): void {
    this._onModelChange = fn;
  }

  public registerOnTouched(fn: any): void {
  }

  public writeValue(value: boolean): void {
    this.value = value;
  }

  public onChange(event: any): void {
    this.value = event.target.checked;
    this._onModelChange(this.value);
  }
}
